import { EXPANDED_LANDING_PAGES } from './expandedLandingPages.js';
// Public service-page content only. No visitor or patient data belongs here.
export const SERVICE_LANDING_PAGES = {
  "/dental-implants": {
    "page": "DentalImplants",
    "label": "Dental implants",
    "intent": "implant",
    "color": "amber",
    "summary": "Explore replacement options for one missing tooth or a full arch.",
    "steps": [
      "Review your health and bone support",
      "Compare single-tooth and full-arch options",
      "Receive an individual treatment plan"
    ]
  },
  "/single-implant": {
    "page": "SingleImplant",
    "label": "Single tooth implants",
    "intent": "implant",
    "color": "blue",
    "summary": "Replace one missing tooth with an implant-supported crown when clinically suitable.",
    "steps": [
      "Discuss the missing tooth and surrounding teeth",
      "Review imaging and implant suitability",
      "Understand the complete treatment fee"
    ]
  },
  "/full-mouth-restoration": {
    "page": "FullMouthRestoration",
    "label": "Full mouth reconstruction",
    "intent": "implant",
    "color": "purple",
    "summary": "Plan care for multiple worn, damaged or missing teeth around your health, bite and goals.",
    "steps": [
      "Discuss function, comfort and appearance",
      "Compare restorative treatment options",
      "Plan treatment stages and costs"
    ]
  },
  "/cosmetic-dentistry": {
    "page": "CosmeticDentistry",
    "label": "Cosmetic dentistry",
    "intent": "consult",
    "color": "rose",
    "summary": "Compare veneers, bonding, whitening and aligners with a dentist who can assess your smile.",
    "steps": [
      "Share what you would like to change",
      "Review suitable options and limitations",
      "Discuss a written plan and fees"
    ]
  },
  "/invisalign": {
    "page": "Invisalign",
    "label": "Invisalign",
    "intent": "consult",
    "color": "sky",
    "summary": "Explore clear aligners with a dental examination, a digital plan and ongoing professional care.",
    "steps": [
      "Check teeth, gums and bite",
      "Discuss aligner wear and treatment time",
      "Review fees, refinements and retainers"
    ]
  },
  "/general-dentistry": {
    "page": "GeneralDentistry",
    "label": "General dentistry",
    "intent": "call",
    "color": "teal",
    "summary": "Arrange an exam, cleaning or restorative visit with our Trinity dental team.",
    "steps": [
      "Tell our team the type of visit you need",
      "Confirm appointment availability and fees",
      "Review care recommended after your exam"
    ]
  },
  "/preventative-dentistry": {
    "page": "PreventativeDentistry",
    "label": "Cleanings and preventive care",
    "intent": "call",
    "color": "green",
    "summary": "Start with an examination and a cleaning schedule suited to your oral health.",
    "steps": [
      "Ask about a new-patient or recall visit",
      "Confirm insurance and expected fees",
      "Plan ongoing preventive care"
    ]
  },
  "/same-day-crowns": {
    "page": "SameDayCrowns",
    "label": "Same-day crowns",
    "intent": "call",
    "color": "indigo",
    "summary": "Explore an in-house CEREC crown; one-visit treatment depends on your tooth and clinical needs.",
    "steps": [
      "Have the damaged tooth examined",
      "Check whether a one-visit crown is suitable",
      "Review the restoration and its cost"
    ]
  },
  "/emergency-dentistry": {
    "page": "EmergencyDentistry",
    "label": "Urgent dental care",
    "intent": "urgent",
    "color": "red",
    "summary": "Call for dental pain, a broken tooth or another urgent concern. Our team can discuss the next available visit.",
    "steps": [
      "Call during office hours",
      "Describe your concern to the team",
      "Confirm availability before traveling"
    ]
  },
  "/laser-dentistry": {
    "page": "LaserDentistry",
    "label": "Laser dentistry",
    "intent": "call",
    "color": "cyan",
    "summary": "Ask whether a dental laser is appropriate for your specific treatment.",
    "steps": [
      "Have the area examined",
      "Compare suitable treatment methods",
      "Discuss comfort, recovery and fees"
    ]
  },
  "/oral-surgery": {
    "page": "OralSurgery",
    "label": "Oral surgery",
    "intent": "call",
    "color": "emerald",
    "summary": "Discuss extractions, implant surgery or grafting with an individual surgical plan.",
    "steps": [
      "Review your history and dental concern",
      "Discuss imaging and treatment options",
      "Plan preparation, aftercare and fees"
    ]
  },
  "/tooth-extractions": {
    "page": "ToothExtractions",
    "label": "Tooth extractions",
    "intent": "call",
    "color": "amber",
    "summary": "Find out whether a tooth can be restored or needs removal, and discuss replacement options.",
    "steps": [
      "Have the tooth and surrounding area examined",
      "Discuss comfort and replacement options",
      "Review aftercare and total fees"
    ]
  },
  "/sedation-dentistry": {
    "page": "SedationDentistry",
    "label": "Sedation dentistry",
    "intent": "call",
    "color": "purple",
    "summary": "Tell us about dental anxiety so we can discuss comfort options before treatment.",
    "steps": [
      "Review your health and medications",
      "Discuss suitable comfort and sedation options",
      "Confirm preparation and transport instructions"
    ]
  },
  "/periodontal-disease-treatment": {
    "page": "PeriodontalDiseaseTreatment",
    "label": "Gum disease treatment",
    "intent": "call",
    "color": "teal",
    "summary": "Arrange an assessment for bleeding gums, gum recession or periodontal concerns.",
    "steps": [
      "Assess your gums and supporting tissues",
      "Discuss appropriate treatment options",
      "Plan follow-up and maintenance"
    ]
  },
  "/dental-bridges": {
    "page": "DentalBridges",
    "label": "Dental bridges",
    "intent": "consult",
    "color": "sky",
    "summary": "Compare tooth-supported and implant-supported ways to replace missing teeth.",
    "steps": [
      "Review the gap and supporting teeth",
      "Compare a bridge with other suitable options",
      "Discuss treatment stages and fees"
    ]
  },
  "/dentures": {
    "page": "Dentures",
    "label": "Fixed alternatives to dentures",
    "intent": "implant",
    "color": "amber",
    "summary": "Explore fixed implant teeth as an alternative to removable dentures. Removable snap-in dentures are not offered.",
    "steps": [
      "Discuss problems with your current teeth",
      "Assess suitability for fixed implant teeth",
      "Review costs and long-term maintenance"
    ]
  },
  "/sinus-grafts": {
    "page": "SinusGrafts",
    "label": "Sinus grafts",
    "intent": "implant",
    "color": "teal",
    "summary": "Find out whether sinus grafting is needed before upper-jaw implant treatment.",
    "steps": [
      "Review your imaging and sinus area",
      "Discuss grafting and implant options",
      "Understand healing stages and costs"
    ]
  },
  "/bone-grafting": {
    "page": "BoneGrafting",
    "label": "Dental bone grafting",
    "intent": "implant",
    "color": "amber",
    "summary": "Discuss whether bone grafting is needed as part of your implant or extraction plan.",
    "steps": [
      "Review the proposed treatment area",
      "Compare clinically appropriate options",
      "Discuss timing, recovery and costs"
    ]
  },
  "/regenerative-dentistry": {
    "page": "RegenerativeDentistry",
    "label": "Regenerative dentistry",
    "intent": "implant",
    "color": "violet",
    "summary": "Ask how grafting or platelet-based techniques may fit your individual treatment plan.",
    "steps": [
      "Review the underlying dental problem",
      "Discuss benefits, limitations and alternatives",
      "Understand the plan and expected fees"
    ]
  },
  "/tmj-treatment": {
    "page": "TMJTreatment",
    "label": "Jaw pain and TMJ evaluation",
    "intent": "call",
    "color": "amber",
    "summary": "Arrange an evaluation for jaw pain or limited movement and discuss conservative care options.",
    "steps": [
      "Review symptoms and dental history",
      "Discuss examination findings",
      "Consider conservative care or referral"
    ]
  },
  "/sleep-apnea-treatment": {
    "page": "SleepApneaTreatment",
    "label": "Sleep apnea oral appliances",
    "intent": "call",
    "color": "amber",
    "summary": "Discuss a custom oral appliance as part of physician-directed sleep apnea care.",
    "steps": [
      "Review your diagnosis and physician recommendations",
      "Assess suitability for an oral appliance",
      "Plan fitting and follow-up care"
    ]
  },
  "/mini-dental-implants": {
    "page": "MiniDentalImplants",
    "label": "Alternatives to mini dental implants",
    "intent": "implant",
    "color": "amber",
    "summary": "We place standard implants, not mini implants. Discuss whether a standard implant is appropriate for you.",
    "steps": [
      "Review the missing tooth and bone support",
      "Compare suitable replacement options",
      "Review your individual treatment plan"
    ]
  },
  "/snap-in-dentures": {
    "page": "SnapInDentures",
    "label": "Alternatives to snap-in dentures",
    "intent": "implant",
    "color": "amber",
    "summary": "We offer fixed implant teeth, not removable snap-in dentures. Compare options before making a decision.",
    "steps": [
      "Discuss what you need from replacement teeth",
      "Assess suitability for fixed implant teeth",
      "Review costs and maintenance"
    ]
  },
  "/services": {
    "page": "Services",
    "label": "Dental care",
    "intent": "call",
    "color": "amber",
    "summary": "Find the right next step for your dental concern, from routine care to restorative treatment.",
    "steps": [
      "Choose the service you want to discuss",
      "Call our team about the appropriate visit",
      "Confirm availability and fees"
    ]
  }
};

export function getServiceLanding(path = "") {
  const key = path.replace(/\/$/, "") || "/";
  return SERVICE_LANDING_PAGES[key] || EXPANDED_LANDING_PAGES[key] || null;
}
